import { apiClient } from "features/shared/api/axiosInstance";
import type { PaginatedPartnersDto } from "common/models/api/models/PaginatedPartnersDto";
import type { PartnerDto } from "common/models/api/models/PartnerDto";
import type { PartnerKpisDto } from "common/models/api/models/PartnerKpisDto";
import type { PartnerPointsOfSellKpisDto } from "common/models/api/models/PartnerPointsOfSellKpisDto";
import type { PartnerRedeemPointsRequest } from "common/models/api/models/PartnerRedeemPointsRequest";
import type { UpdatePartnerAdminRequest } from "common/models/api/models/UpdatePartnerAdminRequest";
import type { UpdatePartnerRequest } from "common/models/api/models/UpdatePartnerRequest";

type PartnerType = "online-store" | "physical-store" | "online-and-physical-store" | "giftcard";

export const partnersApi = {
    kpis: () => apiClient.get<PartnerKpisDto>("/api/partners/kpis"),

    findAll: (params: {
        page?: number;
        pageSize?: number;
        query?: string;
        order?: "ASC" | "DESC";
        orderBy?: string;
        type?: PartnerType;
        organizationAddress?: string;
        archived?: boolean;
        belongsToOtherAlly?: boolean;
        parentAddress?: string;
    }) => apiClient.get<PaginatedPartnersDto>("/api/partners", { params }),

    findAllWithoutParent: (params: {
        page?: number;
        pageSize?: number;
        query?: string;
        order?: "ASC" | "DESC";
        orderBy?: string;
        type?: PartnerType;
        organizationAddress?: string;
        archived?: boolean;
        belongsToOtherAlly?: boolean;
        parentAddress?: string;
    }) => apiClient.get<PaginatedPartnersDto>("/api/partners/find-all-without-parent", { params }),

    create: (formData: FormData) =>
        apiClient.post<PartnerDto>("/api/partners", formData, {
            headers: { "Content-Type": "multipart/form-data" },
        }),

    findByAddress: (address: string) => apiClient.get<PartnerDto>(`/api/partners/${address}`),

    updatePartner: (address: string, body: UpdatePartnerRequest) => apiClient.put<PartnerDto>(`/api/partners/${address}`, body),

    getBalance: (address: string) => apiClient.get<string>(`/api/partners/${address}/balance`),

    updatePartnerAdmin: (address: string, body: UpdatePartnerAdminRequest) => apiClient.put(`/api/partners/${address}/admin`, body),

    redeemPoints: (body: PartnerRedeemPointsRequest) => apiClient.post("/api/partners/redeem", body),

    archivePartner: (address: string) => apiClient.put(`/api/partners/${address}/archive`),

    exportPartners: (params?: {
        query?: string;
        order?: "ASC" | "DESC";
        orderBy?: string;
        type?: PartnerType;
        organizationAddress?: string;
        archived?: boolean;
    }) => apiClient.get<string>("/api/partners/export", { params }),

    findPointsOfSellByAddress: (address: string) =>
        apiClient.get<Array<PartnerPointsOfSellKpisDto>>(`/api/partners/point-of-sell/${address}`),
};
